import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const isReadOnlySelectorFactory = ({ readOnlyHardwareModels = [] }) => (getWalletAccount) => (name) => {
    const walletAccount = getWalletAccount(name);
    return walletAccount?.model ? readOnlyHardwareModels.includes(walletAccount.model) : false;
};
const createIsReadOnlySelectorDefinition = (config) => defineSelectorResultFunction({
    id: 'isReadOnly',
    resultFunction: isReadOnlySelectorFactory(config),
    dependencies: [
        { selector: 'get' },
    ],
});
export default createIsReadOnlySelectorDefinition;
